module.exports = __webpack_public_path__ + "img/MilitaryTechBackgroundC04_ua.2ec92b36.webp";